import { render, staticRenderFns } from "./HostMenu.vue?vue&type=template&id=f4d0825a&scoped=true&"
import script from "./HostMenu.vue?vue&type=script&lang=js&"
export * from "./HostMenu.vue?vue&type=script&lang=js&"
import style0 from "./HostMenu.vue?vue&type=style&index=0&id=f4d0825a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d0825a",
  null
  
)

export default component.exports